var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 92,
    height: 125,
    viewBox: "0 0 92 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8836_20472)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 182.288,
    height: 124.724,
    fill: "#E9ECEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.59424,
    y: 9.59375,
    width: 71.956,
    height: 105.535,
    rx: 3.19804,
    fill: "#CED4DA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8836_20472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 91.1442,
    height: 124.724,
    rx: 4.79707,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.108fd39fe76e72c94cd88db16e239176.svg";
export { ForwardRef as ReactComponent };